export type ImportMoveOptions = 'AllowDuplicateFileContent' | 'AutomaticRename';

export const ImportMoveOptions = {
  AllowDuplicateFileContent: 'AllowDuplicateFileContent' as ImportMoveOptions,
  AutomaticRename: 'AutomaticRename' as ImportMoveOptions,
};
